/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {DataEmailDto} from '../model/dataEmailDto';
import {KeyValueOfstringAndstring} from '../model/keyValueOfstringAndstring';
import {LandingPage} from '../model/landingPage';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class EngineTransactionalEmailService {

    protected basePath = 'https://dmp.airiane.com/services/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createLandingPage
     *
     * @param landingPage landingPage
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createLandingPageUsingPOST(landingPage: LandingPage, observe?: 'body', reportProgress?: boolean): Observable<LandingPage>;
    public createLandingPageUsingPOST(landingPage: LandingPage, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LandingPage>>;
    public createLandingPageUsingPOST(landingPage: LandingPage, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LandingPage>>;
    public createLandingPageUsingPOST(landingPage: LandingPage, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (landingPage === null || landingPage === undefined) {
            throw new Error('Required parameter landingPage was null or undefined when calling createLandingPageUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<LandingPage>(`${this.basePath}/api/transactional-email/landing-pages`,
            landingPage,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllLandingPages
     *
     * @param queryParams queryParams
     * @param page Page number of the requested page
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllLandingPagesUsingGET(queryParams: any, page?: number, size?: number, sort?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<LandingPage>>;
    public getAllLandingPagesUsingGET(queryParams: any, page?: number, size?: number, sort?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LandingPage>>>;
    public getAllLandingPagesUsingGET(queryParams: any, page?: number, size?: number, sort?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LandingPage>>>;
    public getAllLandingPagesUsingGET(queryParams: any, page?: number, size?: number, sort?: Array<string>, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (queryParams === null || queryParams === undefined) {
            throw new Error('Required parameter queryParams was null or undefined when calling getAllLandingPagesUsingGET.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (queryParams !== undefined && queryParams !== null) {
            queryParameters = queryParameters.set('queryParams', <any>queryParams);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<LandingPage>>(`${this.basePath}/api/transactional-email/landing-pages`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getDatasets
     *
     * @param xDataStoreID X-DataStoreID
     * @param etl etl
     * @param id id
     * @param idDatasets idDatasets
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDatasetsUsingGET(xDataStoreID: string, etl: string, id: string, idDatasets: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: string; }>;
    public getDatasetsUsingGET(xDataStoreID: string, etl: string, id: string, idDatasets: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: string; }>>;
    public getDatasetsUsingGET(xDataStoreID: string, etl: string, id: string, idDatasets: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: string; }>>;
    public getDatasetsUsingGET(xDataStoreID: string, etl: string, id: string, idDatasets: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getDatasetsUsingGET.');
        }

        if (etl === null || etl === undefined) {
            throw new Error('Required parameter etl was null or undefined when calling getDatasetsUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDatasetsUsingGET.');
        }

        if (idDatasets === null || idDatasets === undefined) {
            throw new Error('Required parameter idDatasets was null or undefined when calling getDatasetsUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (etl !== undefined && etl !== null) {
            queryParameters = queryParameters.set('etl', <any>etl);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<{ [key: string]: string; }>(`${this.basePath}/api/transactional-email/${encodeURIComponent(String(id))}/playground/datasets/${encodeURIComponent(String(idDatasets))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getListDatasets
     *
     * @param xDataStoreID X-DataStoreID
     * @param etl etl
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getListDatasetsUsingGET(xDataStoreID: string, etl: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<Array<KeyValueOfstringAndstring>>;
    public getListDatasetsUsingGET(xDataStoreID: string, etl: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<KeyValueOfstringAndstring>>>;
    public getListDatasetsUsingGET(xDataStoreID: string, etl: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<KeyValueOfstringAndstring>>>;
    public getListDatasetsUsingGET(xDataStoreID: string, etl: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getListDatasetsUsingGET.');
        }

        if (etl === null || etl === undefined) {
            throw new Error('Required parameter etl was null or undefined when calling getListDatasetsUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getListDatasetsUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (etl !== undefined && etl !== null) {
            queryParameters = queryParameters.set('etl', <any>etl);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<KeyValueOfstringAndstring>>(`${this.basePath}/api/transactional-email/${encodeURIComponent(String(id))}/playground/datasets`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getPreview
     *
     * @param xDataStoreID X-DataStoreID
     * @param etl etl
     * @param id id
     * @param idDatasets idDatasets
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPreviewUsingGET(xDataStoreID: string, etl: string, id: string, idDatasets: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: any; }>;
    public getPreviewUsingGET(xDataStoreID: string, etl: string, id: string, idDatasets: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: any; }>>;
    public getPreviewUsingGET(xDataStoreID: string, etl: string, id: string, idDatasets: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: any; }>>;
    public getPreviewUsingGET(xDataStoreID: string, etl: string, id: string, idDatasets: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getPreviewUsingGET.');
        }

        if (etl === null || etl === undefined) {
            throw new Error('Required parameter etl was null or undefined when calling getPreviewUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getPreviewUsingGET.');
        }

        if (idDatasets === null || idDatasets === undefined) {
            throw new Error('Required parameter idDatasets was null or undefined when calling getPreviewUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (etl !== undefined && etl !== null) {
            queryParameters = queryParameters.set('etl', <any>etl);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<{ [key: string]: any; }>(`${this.basePath}/api/transactional-email/${encodeURIComponent(String(id))}/playground/datasets/${encodeURIComponent(String(idDatasets))}/preview`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * sendEmail
     *
     * @param xDataStoreID X-DataStoreID
     * @param emails emails
     * @param etl etl
     * @param id id
     * @param idDatasets idDatasets
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendEmailUsingGET(xDataStoreID: string, emails: Array<string>, etl: string, id: string, idDatasets: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public sendEmailUsingGET(xDataStoreID: string, emails: Array<string>, etl: string, id: string, idDatasets: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public sendEmailUsingGET(xDataStoreID: string, emails: Array<string>, etl: string, id: string, idDatasets: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public sendEmailUsingGET(xDataStoreID: string, emails: Array<string>, etl: string, id: string, idDatasets: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling sendEmailUsingGET.');
        }

        if (emails === null || emails === undefined) {
            throw new Error('Required parameter emails was null or undefined when calling sendEmailUsingGET.');
        }

        if (etl === null || etl === undefined) {
            throw new Error('Required parameter etl was null or undefined when calling sendEmailUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling sendEmailUsingGET.');
        }

        if (idDatasets === null || idDatasets === undefined) {
            throw new Error('Required parameter idDatasets was null or undefined when calling sendEmailUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (emails) {
            emails.forEach((element) => {
                queryParameters = queryParameters.append('emails', <any>element);
            })
        }
        if (etl !== undefined && etl !== null) {
            queryParameters = queryParameters.set('etl', <any>etl);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<boolean>(`${this.basePath}/api/transactional-email/${encodeURIComponent(String(id))}/playground/datasets/${encodeURIComponent(String(idDatasets))}/send`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * sendTestEmail
     *
     * @param xDataStoreID X-DataStoreID
     * @param emails emails
     * @param id id
     * @param params params
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendTestEmailUsingPOST(xDataStoreID: string, emails: Array<string>, id: string, params: DataEmailDto, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public sendTestEmailUsingPOST(xDataStoreID: string, emails: Array<string>, id: string, params: DataEmailDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public sendTestEmailUsingPOST(xDataStoreID: string, emails: Array<string>, id: string, params: DataEmailDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public sendTestEmailUsingPOST(xDataStoreID: string, emails: Array<string>, id: string, params: DataEmailDto, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling sendTestEmailUsingPOST.');
        }

        if (emails === null || emails === undefined) {
            throw new Error('Required parameter emails was null or undefined when calling sendTestEmailUsingPOST.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling sendTestEmailUsingPOST.');
        }

        if (params === null || params === undefined) {
            throw new Error('Required parameter params was null or undefined when calling sendTestEmailUsingPOST.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (emails) {
            emails.forEach((element) => {
                queryParameters = queryParameters.append('emails', <any> element);
            });
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<boolean>(`${this.basePath}/api/transactional-email/${encodeURIComponent(String(id))}/send/test`,
            params,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateLandingPage
     *
     * @param landingPage landingPage
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateLandingPageUsingPUT(landingPage: LandingPage, observe?: 'body', reportProgress?: boolean): Observable<LandingPage>;
    public updateLandingPageUsingPUT(landingPage: LandingPage, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LandingPage>>;
    public updateLandingPageUsingPUT(landingPage: LandingPage, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LandingPage>>;
    public updateLandingPageUsingPUT(landingPage: LandingPage, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (landingPage === null || landingPage === undefined) {
            throw new Error('Required parameter landingPage was null or undefined when calling updateLandingPageUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<LandingPage>(`${this.basePath}/api/transactional-email/landing-pages`,
            landingPage,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
